import axios from '@/plugins/axios';

interface InfoReadItem {
  value: string;
  lastUpdated: string;
}

const normalizeInfoReadItems = (data: unknown): InfoReadItem[] => {
  if (data === '' || data === null || data === undefined) return [];
  if (!Array.isArray(data)) throw new TypeError('Invalid info-read response');
  return data;
};

export const getInfoRead = async (context: string):Promise<InfoReadItem[]> => {
  const response = await axios.get(`/v1/users/user/info-read/${context}`);
  return normalizeInfoReadItems(response?.data);
};

export const postInfoRead = async (context: string, value: string):Promise<boolean> => {
  try {
    await axios.post(`/v1/users/user/info-read/${context}/${value}`);
    return true;
  } catch (e: any) {
    return false;
  }
};

export const deleteInfoRead = async (context: string, value: string):Promise<boolean> => {
  try {
    await axios.delete(`/v1/users/user/info-read/${context}/${value}`);
    return true;
  } catch (e: any) {
    return false;
  }
};
